export default "__VITE_ASSET__8b163eee__"